module.exports = __webpack_public_path__ + "img/Pfade_Tabea_12.34301792.png";